import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import { useCallback, useState } from 'react';

interface IMenuItem {
  title: string;
  handleClick?: (isOpen: boolean) => void;
  defaultOpen?: boolean;
  children?: any;
}

const useStyles = makeStyles(() => ({
  details: {
    padding: 0,
    display: 'block',
  },
  // each section is its own white rounded card, 4px apart
  accordion: {
    margin: 4,
    border: '1px solid #EBEBEB',
    borderRadius: '16px !important',
    overflow: 'hidden',
    backgroundColor: '#fff',
    '&.Mui-expanded': {
      margin: 4,
    },
    '&::before': {
      display: 'none',
    },
  },
  accordionSummary: {
    fontWeight: 700,
    minHeight: 44,
    backgroundColor: '#fff',
    color: '#1B1D34',
    '&.Mui-expanded': {
      minHeight: 44,
      borderBottom: '1px solid #EBEBEB',
    },
    '& .MuiAccordionSummary-content': {
      margin: '10px 0',
    },
    '& .MuiAccordionSummary-content p': {
      margin: 0,
    },
  },
}));

export const ConversationExpandableMenu = ({
  children,
  defaultOpen = false,
  handleClick,
  title,
}: IMenuItem) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(defaultOpen);

  const onClick = useCallback(() => {
    setOpen(!isOpen);
    if (handleClick) handleClick(!isOpen);
  }, [isOpen]);

  return (
    <Accordion defaultExpanded={isOpen} elevation={0} onClick={onClick} className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`${title}-content`}
        id={title}
        className={classes.accordionSummary}
      >
        <p>{title}</p>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
